// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [];

module.exports = angular
  .module('bench.data.actions.auth', deps)

  .factory('AuthActions', () => ({
    authenticate() {
      return 'bl.auth.authenticate';
    },
  }));
